const GLOBAL: any = window;

export default () => {
  if (!GLOBAL.jsonLoginInfo) {
    return undefined;
  }

  return GLOBAL.jsonLoginInfo.fLoginLanguage;
};
